






import Vue from 'vue'

export default Vue.extend({
  name: 'App',
  components: {},
  created() {
    this.$vuetify.theme.dark = localStorage.getItem('theme.dark') !== 'false'
  },
})
